import React, { useEffect, useRef, useState } from "react";
import "./CvDownloadDropdown.css";

const cvFilesByLanguage = {
  es: {
    pdf: {
      href: "/cv/CV_Mario_Vidal_ES.pdf",
      fileName: "CV_Mario_Vidal_ES.pdf",
    },
    word: {
      href: "/cv/CV_Mario_Vidal_ES.docx",
      fileName: "CV_Mario_Vidal_ES.docx",
    },
  },
  en: {
    pdf: {
      href: "/cv/CV_Mario_Vidal_EN.pdf",
      fileName: "CV_Mario_Vidal_EN.pdf",
    },
    word: {
      href: "/cv/CV_Mario_Vidal_EN.docx",
      fileName: "CV_Mario_Vidal_EN.docx",
    },
  },
};

function CvDownloadDropdown({
  isEnglish,
  className = "",
  variant = "default",
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const languageKey = isEnglish ? "en" : "es";
  const cvFiles = cvFilesByLanguage[languageKey];
  const label = isEnglish ? "Download CV" : "Descargar CV";

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (!dropdownRef.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("touchstart", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("touchstart", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleToggle = () => {
    setIsOpen((currentValue) => !currentValue);
  };

  const handleOptionClick = () => {
    setIsOpen(false);
  };

  return (
    <div
      ref={dropdownRef}
      className={`cv-download ${isOpen ? "cv-download--open" : ""} ${className}`.trim()}
    >
      <button
        type="button"
        className={`button button--flex cv-download__trigger ${
          variant === "primary" ? "button--active-static" : ""
        }`.trim()}
        onClick={handleToggle}
        aria-expanded={isOpen}
        aria-haspopup="menu"
      >
        {label}
        <i className="uil uil-angle-down cv-download__trigger-icon button__icon"></i>
      </button>

      {isOpen && (
        <div className="cv-download__menu" role="menu">
          <a
            download={cvFiles.pdf.fileName}
            href={cvFiles.pdf.href}
            className="cv-download__option"
            onClick={handleOptionClick}
          >
            <span>PDF</span>
            <i className="uil uil-file-download-alt cv-download__option-icon"></i>
          </a>

          <button
            type="button"
            className="cv-download__option cv-download__option--disabled"
            role="menuitem"
            disabled
          >
            <span>WORD</span>
            <i className="uil uil-file-download-alt cv-download__option-icon"></i>
          </button>
        </div>
      )}
    </div>
  );
}

export default CvDownloadDropdown;
